module.exports = __webpack_public_path__ + "img/um.66829204.svg";